import Vue from 'vue';
import NotificationHolder from './NotificationHolder.vue';
const NotificationHolderConstructor = Vue.extend(NotificationHolder)

export default class Notification {
  static holder;

  /**
   * Mount notification holder if it doesn't already exist & return Vue component
   * @returns {object} - Vue component}
   */
  static getHolder() {
    if (this.holder === undefined) {
      this.holder = new NotificationHolderConstructor().$mount();
      document.body.appendChild(this.holder.$el);
    }
    return this.holder
  }

  /**
   * Build notification and mount Vue component into notification holder
   * @param {string} type - Type of notification
   * @param {string} title - Header of the notification
   * @param {boolean} closeAutomatically - If false, won't close automatically. Default true
   * @param {html} content - Body of the notification, if any
   * @param {boolean} isOpen - If true, notification body will be open on desktop
   * @returns {void}
   */
  static displayNotification(type, title, closeAutomatically, content, isOpen) {
    this.getHolder().addNotification({
      type: type,
      title: title,
      closeAutomatically: closeAutomatically,
      body: content,
      isOpen: isOpen
    })
  }

  /**
   * Display success notification
   * @param {string} title - Name of the notification
   * @param {boolean} closeAutomatically - If false, won't close automatically. Default true
   * @param {html} content - Content of the notification, if any
   * @param {boolean} isOpen - If true, notification body will be open on desktop
   * @returns {void}
   */
  static success(title, closeAutomatically, content, isOpen) {
    this.displayNotification('success', title, closeAutomatically, content, isOpen)
  }

  /**
   * Display warning notification
   * @param {string} title - Name of the notification
   * @param {boolean} closeAutomatically - If false, won't close automatically. Default true
   * @param {html} content - Content of the notification, if any
   * @param {boolean} isOpen - If true, notification body will be open on desktop
   * @returns {void}
   */
  static warning(title, closeAutomatically, content, isOpen) {
    this.displayNotification('warning', title, closeAutomatically, content, isOpen)
  }

  /**
   * Display failure notification
   * @param {string} title - Name of the notification
   * @param {boolean} closeAutomatically - If false, won't close automatically. Default true
   * @param {html} content - Content of the notification, if any
   * @param {boolean} isOpen - If true, notification body will be open on desktop
   * @returns {void}
   */
  static failure(title, closeAutomatically, content, isOpen) {
    this.displayNotification('failure', title, closeAutomatically, content, isOpen)
  }
}
